module.exports = {"230522100":"友谊镇","230522101":"兴隆镇","230522102":"龙山镇","230522103":"凤岗镇","230522200":"兴盛乡","230522201":"东建乡","230522202":"庆丰乡","230522203":"建设乡","230522204":"友邻乡","230522205":"新镇乡","230522206":"成富朝鲜族满族乡","230522501":"红兴隆管理局局直","230522502":"友谊农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230522.json
// module id = 817
// module chunks = 0